import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface ICellRendererParamsForFormReportListGridAction extends ICellRendererParams {
    edit: (params: ICellRendererParamsForFormReportListGridAction) => void;
    getEditTitle: (params: ICellRendererParamsForFormReportListGridAction) => string;
    canEdit: (params: ICellRendererParamsForFormReportListGridAction) => boolean;
    canEnterEditMode: (params: ICellRendererParamsForFormReportListGridAction) => boolean;
    canRemove: (params: ICellRendererParamsForFormReportListGridAction) => boolean;
    remove: (params: ICellRendererParamsForFormReportListGridAction) => void;
    canUndoRemove: (params: ICellRendererParamsForFormReportListGridAction) => boolean;
    undoRemove: (params: ICellRendererParamsForFormReportListGridAction) => void;
}

@Component({
    selector: 'form-report-list-grid-action-cell',
    template: `
    <div class="grid-action-button-wrapper" [title]="params.getEditTitle(params)">
      @if (params.canEdit(params)) {
        <button [disabled]="!params.canEnterEditMode(params)" type="button" class="ace-btn btn-primary has-icon grid-action-button" title="Edit" (click)="params.edit(params)">
          <i class="fa fa-pencil"></i>
        </button>
      }
    </div>
    @if (!params.canEdit(params)) {
      <i class="fa fa-fw"></i>
    }
    @if (params.data && !params.canEdit(params)) {
      <i class="fa fa-fw"></i>
    }
    @if (params.canRemove(params)) {
      <button class="ace-btn has-icon btn-primary btn-danger grid-action-button" title="Remove" (click)="params.remove(params)">
        <i class="fa fa-times"></i>
      </button>
    }
    @if (params.canUndoRemove(params)) {
      <button class="ace-btn has-icon success-button grid-action-button" title="Undo Remove" (click)="params.undoRemove(params)">
        <i class="fa fa-undo"></i>
      </button>
    }
    `,
    standalone: false
})
export class FormReportListGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: ICellRendererParamsForFormReportListGridAction;

    agInit(params: ICellRendererParamsForFormReportListGridAction): void {
        this.params = params;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
